import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindConseilsPersonnalisesContent($id: String!)
{
  findConseilsPersonnalisesContent(id: $id) {
    data {
      pageTitle {
        iv
      }
      titleBlocTitle {
        iv
      }
      titleBlocSubTitle {
        iv
      }
      titleBlocFontSizeTitle {
        iv
      }
      titleBlocFontSizeSubTitle {
        iv
      }
      titleBlocWidth {
        iv
      }
      titleBlocTagline {
        iv
      }
      titleBlocTextColor {
        iv
      }
      titleBlocColor {
        iv
      }
      titleBlocCtaLink {
        iv
      }
      titleBlocCtaText {
        iv
      }
      titleBlocCtaStyle {
        iv
      }
      titleBlocCtaLink2 {
        iv
      }
      titleBlocCtaText2 {
        iv
      }
      titleBlocCtaStyle2 {
        iv
      }
      titleBlocPicture {
        iv {
          url
          fileSize
        }
      }
      titleBlocHorizontalPosition {
        iv
      }
      titleBlocVerticalPosition {
        iv
      }
      titleBlocJustification {
        iv
      }

      text {
        iv
      }
      textFontSize {
        iv
      }
      textColor {
        iv
      }

      staggeredImages{
        iv {
          leftText
          leftTextFontSize
          leftTextColor
          leftTextAlignment
          leftPicture{
            url
            fileSize
          }
          leftVideoLink
          leftVideoPlaceholder {
              url
              fileSize
          }
          rightText
          rightTextFontSize
          rightTextColor
          rightTextAlignment
          rightPicture{
            url
            fileSize
          }
          rightVideoLink
          rightVideoPlaceholder {
              url
              fileSize
          }
        }
      }

      zoomedRibbonTitle {
        iv
      }
      zoomedRibbonColor {
        iv
      }
      zoomedRibbonTextColor {
        iv
      }
      zoomedRibbonElementByLine {
        iv
      }
      zoomedRibbonItems {
        iv {
          picture {
            url
            fileSize
          }
          title
        }
      }

      videoLink {
        iv
      }
      videoPlaceholder {
        iv {
          url
          fileSize
        }
      }

      advantageTitle {
        iv
      }
      advantage {
        iv
      }

      news {
        iv {
          title
          subTitle
          ctaLink
          ctaText
          ctaStyle
          picture {
            url
            fileSize
          }
        }
      }

      logo {
        iv {
          url
          fileSize
        }
      }

      mention {
        iv
      }
      mentionFontSize {
        iv
      }
      mentionTextColor {
        iv
      }

    }
  }
}
`,
]);
